// extracted by mini-css-extract-plugin
export var searchHeader = "_9y-0";
export var searchHeaderDark = "_9y-1";